import ConversationRepository from '../../ports/ConversationRepository';
import { Conversation } from '../../../domain/entities';

export type getConversationsWithInstructorsUseCase = (
  userId: string,
  instructorsIds: string[],
) => Promise<{ conversations: Conversation[]; adminConvo: Conversation }>;

export const buildGetConversationsWithInstructors = (dependencies: {
  conversationRepo: ConversationRepository;
}): getConversationsWithInstructorsUseCase => {
  const { conversationRepo } = dependencies;

  const getConversationsWithInstructors: getConversationsWithInstructorsUseCase = async (
    userId,
    instructorsIds,
  ) => {
    try {
      const convos = await conversationRepo.fetchConversationsWithInstructors(
        userId,
        instructorsIds,
      );
      const adminConvo = await conversationRepo.fetchConvoWithAdmin(userId);

      return { conversations: convos, adminConvo };
    } catch (error) {
      throw error;
    }
  };

  return getConversationsWithInstructors;
};
